






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import DialogUpload from '@/components/dialog-upload.vue';
import moment from 'moment';
import { post, get, del } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, DialogUpload }
})
export default class UsersList extends Vue {
  created() {
    // console.log(this.api.get('/api/apply/list', this.pageData.info))
  }
  visible: boolean = false;
  pageData: any = {
    url: '/v1/config/app/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      app_id: '',
      app_type: '',
      pagination: {
        page: 1,
        page_size: 10
      }
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'app_id', // 字段
        tip: '应用id',
        msg: '请输入应用id'
      },
      {
        type: 'input', // text框
        model: 'app_type', // 字段
        tip: '类型',
        msg: '请输入类型'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '上传APK',
        methods: 'add',
        type: 'primary',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        {
          prop: 'id',
          label: 'ID',
          width: '80'
        },
        {
          prop: 'app_id',
          label: '应用id'
        },
        {
          prop: 'app_name',
          label: '应用名称',
          width: '200'
        },
        {
          prop: 'app_type',
          label: '类型',
          width: '100'
        },
        {
          prop: 'platform',
          label: '设备系统',
          width: '110'
        },
        {
          prop: 'version_code',
          label: '版本code',
          width: '120'
        },
        {
          prop: 'frequency',
          label: '更新频率/min',
          width: '135'
        },
        {
          prop: 'enable',
          label: '启用',
          width: '100',
          type: 'switch',
          color: 'enable'
        },
        {
          prop: 'Force',
          _prop: 'force',
          label: '强制更新',
          width: '120',
          type: 'tag',
          color: 'force',
          status: {
            true: '是',
            false: '否'
          }
        },
        {
          prop: 'path',
          label: '文件存储路径'
        },
        {
          prop: 'detail',
          label: '描述'
        }
      ],
      expand: [],
      optionWidth: 80,
      option: [
        {
          name: '删除',
          methods: 'delete',
          type: 'text'
        }
      ]
    } // table
  };
  dialogData: any = {
    optionTitle: '上传APK',
    modifyForm: {
      url: '/upload',
      form: {
        orce: true,
        frequency: '',
        detail: '',
        appType: '',
        appName: '',
        versionCode: '',
        appId: ''
      },
      showData: [],
      data: [
        {
          type: 'input',
          model: 'appName',
          name: '上传包名称',
          disabled: false,
          class: 'half'
        },
        {
          type: 'input',
          model: 'appId',
          name: '应用id',
          disabled: false,
          class: 'half'
        },
        {
          type: 'input',
          model: 'versionCode',
          name: '版本号',
          disabled: false,
          class: 'half'
        },
        {
          type: 'number',
          model: 'frequency',
          name: '更新设备数',
          class: 'half',
          afterShow: 'unit',
          unit: '/分钟'
        },
        {
          type: 'switch',
          model: 'orce',
          name: '是否强制更新',
          disabled: false,
          class: 'half'
        },
        {
          type: 'input',
          model: 'appType',
          name: '上传包类型',
          disabled: false,
          class: 'half'
        },
        {
          type: 'textarea',
          model: 'detail',
          name: '描述',
          autosize: '{ minRows: 3, maxRows: 4}',
          disabled: false
        },
        {
          type: 'upload',
          model: 'upload',
          name: '上传文件'
        }
      ],
      formLabelWidth: '100px',
      select: {
        appType: [
          {
            value: 'ios',
            lable: 'ios'
          },
          {
            value: 'android',
            lable: 'android'
          }
        ]
      }
    },
    rules: {
      frequency: [
        {
          required: true,
          message: '请输入分钟更新设备数',
          trigger: 'blur'
        }
      ],
      appType: [
        {
          required: true,
          message: '请选择上传类型',
          trigger: 'blur'
        }
      ],
      appName: [
        {
          required: true,
          message: '请输入上传包名称',
          trigger: 'blur'
        }
      ],
      versionCode: [
        {
          required: true,
          message: '请输入版本号',
          trigger: 'blur'
        }
      ],
      appId: [
        {
          required: true,
          message: '请输入应用id',
          trigger: 'blur'
        }
      ],
      detail: [
        {
          required: true,
          message: '描述也不能为空哦～～～',
          trigger: 'blur'
        }
      ]
    }
  };
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
  private handleClick(methods: string, row: any) {
    if (methods === 'enable') {
      this.$confirm(`是否确认${row.enable ? '开启' : '关闭'}此版本?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          post(`/v1/config/app/${row.id}/enable`, {
            version_id: row.id,
            enable: row.enable
          })
            .then(d => {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              // @ts-ignore
              this.$refs.table.getData();
            })
            .catch(e => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
          // @ts-ignore
          this.$refs.table.getData();
        });
    } else if (methods === 'delete') {
      this.$confirm('是否确认删除此版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(`/v1/config/app/${row.id}`, { id: row.ID })
            .then(d => {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              // @ts-ignore
              this.$refs.table.getData();
            })
            .catch(e => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          // @ts-ignore
          this.$refs.table.getData();
        });
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.visible = true;
    } else {
      // @ts-ignore
      this.$refs.table.getData();
    }
  }
}
